import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import { StButtonLink } from './button-link.styled';
import { props as propsDefinition } from './button-link.shared';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkButtonLink',
  props: propsDefinition,
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: props.to,
    class: "w-fit"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(StButtonLink), _normalizeProps(_guardReactiveProps(_ctx.$attrs)), {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 16)
    ]),
    _: 3
  }, 8, ["to"]))
}
}

})